import script from "./ViewGasPressureValue.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGasPressureValue.vue?vue&type=script&setup=true&lang=js"

import "./ViewGasPressureValue.vue?vue&type=style&index=0&id=22afcd6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22afcd6f"]])

export default __exports__